"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doActions = doActions;
const actions_1 = require("./actions");
/**
 * Execute a list of actions and return a new board state.
 */
function doActions(currentTurn, board, pieceRegistry, id, actions, stores) {
    for (const action of actions) {
        const handler = actions_1.actionFunctions[action.type];
        handler(currentTurn, board, pieceRegistry, id, action, stores);
    }
}
